import { OptionQuestion } from "./question-option";

export class QuestionBase<T> {
    value: T;
    id: string;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    description: string;
    readonly?: boolean;

    constructor(options: {
        value?: T,
        id?: string,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        description?: string,
        options?: OptionQuestion,
        readonly?: boolean
    } = {}) {
        this.value = options.value;
        this.id = options.id;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.description = options.description || '';
        this.readonly = options.readonly || false;
    }
}
